import * as React from 'react';
import { InquiryType, InquiryModes } from 'src/Library/Constants';
import { Icon, Tooltip } from 'src/Library/AntdLibComponents';
import classNames from 'classnames';
import { isValidArray } from 'src/Library/Helper';
import { getBidTotal } from '../InquiryUtils';
import { tokens } from 'src/design-system';

const getEmptyContainerLocation = (type, port) => {
  if (type === InquiryType.EXPORT) {
    return (
      <span>
        Empty Container’s <span style={{ fontWeight: 600 }}>Pick-up</span> will be from{' '}
        <span style={{ fontWeight: 600 }}>{port ?? '-'}</span> Port.
      </span>
    );
  } else {
    return (
      <span>
        Empty container’s <span style={{ fontWeight: 600 }}>Drop-off</span> will be at{' '}
        <span style={{ fontWeight: 600 }}>{port ?? '-'}</span> Port.
      </span>
    );
  }
};

const renderTrailerDestinationDetails = (data, classes) => {
  const destination =
    data.type === InquiryType.EXPORT || data.inquiryType === InquiryType.EXPORT
      ? data.destinationPortDetails || data.destination
      : data.destinationLocationDetails;
  const destinationLabel =
    data.type === InquiryType.EXPORT || data.inquiryType === InquiryType.EXPORT
      ? destination?.name
      : destination?.city || destination?.name;
  return (
    <div className={classes.ellipsis}>
      <Tooltip
        title={destination?.code ? `${destinationLabel} (${destination?.code})` : destinationLabel}
        placement="topLeft"
      >
        <span style={{ color: '#262626', fontSize: `${tokens.fontSize.body}px`, fontWeight: 600 }}>
          {destinationLabel}
        </span>
      </Tooltip>
      {destination?.state && (
        <div
          style={{
            color: tokens.colors.textSecondary,
            fontSize: `${tokens.fontSize.small}px`,
            marginTop: '4px',
          }}
        >
          {destination?.state?.trim()}
        </div>
      )}
      {destination?.pincode && (
        <div
          style={{
            color: tokens.colors.textSecondary,
            fontSize: `${tokens.fontSize.caption}px`,
            marginTop: '4px',
          }}
        >
          {destination?.pincode}
        </div>
      )}
    </div>
  );
};

const renderInquiryDestinationDetails = (classes, data) => {
  const destinationCountry =
    data.destination?.countryName === data.destinationPortDetails?.countryName
      ? ''
      : data.destination?.countryName;

  const isDomesticMode = data.mode === InquiryModes.DOMESTIC || data.inquiryMode === InquiryModes.DOMESTIC ||
    data.mode === InquiryModes.RPTL || data.inquiryMode === InquiryModes.RPTL;

  if (data.mode === InquiryModes.TRAILER || data.inquiryMode === InquiryModes.TRAILER) {
    return renderTrailerDestinationDetails(data, classes);
  }
  if (data.mode === InquiryModes.DOMESTIC || data.inquiryMode === InquiryModes.DOMESTIC ||
      data.mode === InquiryModes.RPTL || data.inquiryMode === InquiryModes.RPTL) {
    return renderDomesticOriginDetails(data?.destinationLocationDetails);
  }
  return (
    <React.Fragment>
      <Tooltip title={data.destinationPortDetails?.countryName}>
        <img
          src={data.destinationPortDetails?.flagS3Link}
          style={{ width: '27px', height: '19px', border: 'solid 1px #e8e8e8' }}
        />
      </Tooltip>
      <br />
      <div className={classes.ellipsis}>
        <Tooltip
          placement='topLeft'
          title={`${data.destinationPortDetails?.name} (${data.destinationPortDetails?.code})`}
        >
          <span style={{ color: '#262626', fontSize: `${tokens.fontSize.body}px`, fontWeight: 600 }}>
            {data.destinationPortDetails?.name}
          </span>
        </Tooltip>
        {destinationCountry?.length > 0 ? (
          <div
            style={{
              fontSize: '8px',
              fontWeight: 800,
              fontStyle: 'italic',
            }}
          >
            <div>Destination Country</div>
            <div
              style={{
                display: 'flex',
                flexDirection: 'row',
                width: '125px',
                paddingRight: '5%',
                whiteSpace: 'normal',
              }}
            >
              {destinationCountry}
            </div>
          </div>
        ) : (
          ''
        )}
        {(data.pickupAndDrop === 'Port to Door' || data.pickupAndDrop === 'Door to Door') &&
        data.destinationAddressDetails ? (
          <div>
            {data.destinationAddressDetails?.city && (
              <Tooltip title={data.destinationAddressDetails?.city}>
                <div
                  className={classes.ellipsis}
                  style={{
                    fontSize: destinationCountry?.length > 0 ? '10px' : '12px',
                    color: tokens.colors.textSecondary,
                    fontWeight: tokens.fontWeight.semibold,
                  }}
                >
                  City: {data.destinationAddressDetails?.city}
                </div>
              </Tooltip>
            )}
            {data.destinationAddressDetails?.state && (
              <Tooltip title={data.destinationAddressDetails?.state?.trim()}>
                <div
                  className={classes.ellipsis}
                  style={{
                    fontSize: destinationCountry?.length > 0 ? '10px' : '12px',
                    color: tokens.colors.textSecondary,
                    fontWeight: tokens.fontWeight.semibold,
                  }}
                >
                  State: {data.destinationAddressDetails?.state?.trim()}
                </div>
              </Tooltip>
            )}
            {data.destinationAddressDetails?.pincode && (
              <Tooltip title={data.destinationAddressDetails?.pincode}>
                <div
                  className={classes.ellipsis}
                  style={{
                    fontSize: destinationCountry?.length > 0 ? '10px' : '12px',
                    color: tokens.colors.textSecondary,
                    fontWeight: tokens.fontWeight.semibold,
                  }}
                >
                  Pincode: {data.destinationAddressDetails?.pincode}
                </div>
              </Tooltip>
            )}
          </div>
        ) : (
          ''
        )}
      </div>
    </React.Fragment>
  );
};

const renderTrailerOriginDetails = (locationDetails) => {
  const TrailerOriginLabel = locationDetails?.city || locationDetails?.name;
  return (
    <React.Fragment>
      <Tooltip title={TrailerOriginLabel} placement="topLeft">
        <span style={{ color: '#262626', fontSize: `${tokens.fontSize.body}px`, fontWeight: 600 }}>
          {TrailerOriginLabel}
        </span>
      </Tooltip>
      {locationDetails?.state && (
        <div style={{
          color: tokens.colors.textSecondary,
          fontSize: `${tokens.fontSize.small}px`,
          marginTop: '4px',
        }}>
          {locationDetails?.state?.trim()}
        </div>
      )}
      {locationDetails?.pincode && <div style={{
        color: tokens.colors.textSecondary,
        fontSize: `${tokens.fontSize.caption}px`,
        marginTop: '4px',
      }}>
        {locationDetails?.pincode}
      </div>}
    </React.Fragment>
  );
};

const renderDomesticOriginDetails = (locationDetails) => {
  const originLabel = locationDetails?.city || locationDetails?.name;
  return (
    <div style={{alignItems: 'center', 
    display:'contents',
    }}>
      {locationDetails?.flagS3Link ? (
        <>
          <Tooltip title={locationDetails?.countryName}>
            <img src={locationDetails?.flagS3Link} style={{ width: '27px', height: '19px' }} />
          </Tooltip>
          <br />
        </>
      ) : (
        ''
      )}
      <Tooltip title={originLabel} placement="topLeft">
        <span style={{ color: '#262626', fontSize: `${tokens.fontSize.body}px`, fontWeight: 600 }}>{originLabel}</span>
      </Tooltip>
      {locationDetails?.state && (
        <div
          style={{
            color: tokens.colors.textSecondary,
            fontSize: `${tokens.fontSize.small}px`,
            marginTop: '4px',
          }}
        >
          {locationDetails?.state?.trim()}
        </div>
      )}
      {locationDetails?.pincode && (
        <div
          style={{
            color: tokens.colors.textSecondary,
            fontSize: `${tokens.fontSize.caption}px`,
            marginTop: '4px',
          }}
        >
          {locationDetails?.pincode}
        </div>
      )}
    </div>
  );
};

const renderInquiryOriginDetails = (classes, data) => {
  if (data.mode === InquiryModes.TRAILER || data.inquiryMode === InquiryModes.TRAILER){
    return renderTrailerOriginDetails(data?.originLocationDetails);
  } else if (data.mode === InquiryModes.DOMESTIC || data.inquiryMode === InquiryModes.DOMESTIC ||
           data.mode === InquiryModes.RPTL || data.inquiryMode === InquiryModes.RPTL) {
    return renderDomesticOriginDetails(data?.originLocationDetails);
  }

  const originCountry =
    data?.origin?.countryName === data?.originPortDetails?.countryName
      ? ''
      : data?.origin?.countryName;

  return (
    <React.Fragment>
      <Tooltip title={data.originPortDetails?.countryName}>
        <img src={data.originPortDetails?.flagS3Link} style={{ width: '27px', height: '19px' }} />
      </Tooltip>
      <br />
      <Tooltip
        title={`${data.originPortDetails?.name} (${data.originPortDetails?.code})`}
        placement="topLeft"
      >
        <span style={{ color: '#262626', fontSize: `${tokens.fontSize.body}px`, fontWeight: 600 }}>
          {data.originPortDetails?.name}
        </span>
      </Tooltip>
      {originCountry?.length > 0 ? (
        <div
          style={{
            fontSize: '8px',
            fontWeight: 800,
            fontStyle: 'italic',
          }}
        >
          <div>Origin Country</div>
          <div
            style={{
              display: 'flex',
              flexDirection: 'row',
              width: '125px',
              paddingRight: '5%',
              whiteSpace: 'normal',
            }}
          >
            {originCountry}
          </div>
        </div>
      ) : (
        ''
      )}
      {(data.pickupAndDrop === 'Door to Port' || data.pickupAndDrop === 'Door to Door') &&
      data.originAddressDetails ? (
        <div>
          {data.originAddressDetails?.city && (
            <Tooltip title={data.originAddressDetails?.city}>
              <div
                className={classes.ellipsis}
                style={{
                  fontSize: originCountry?.length > 0 ? '10px' : '12px',
                  color: tokens.colors.textSecondary,
                  fontWeight: tokens.fontWeight.semibold,
                }}
              >
                City: {data.originAddressDetails?.city}
              </div>
            </Tooltip>
          )}
          {data.originAddressDetails?.state && (
            <Tooltip title={data.originAddressDetails?.state?.trim()}>
              <div
                className={classes.ellipsis}
                style={{
                  fontSize: originCountry?.length > 0 ? '10px' : '12px',
                  color: tokens.colors.textSecondary,
                  fontWeight: tokens.fontWeight.semibold,
                }}
              >
                State: {data.originAddressDetails?.state?.trim()}
              </div>
            </Tooltip>
          )}
          {data.originAddressDetails?.pincode && (
            <Tooltip title={data.originAddressDetails?.pincode}>
              <div
                className={classes.ellipsis}
                style={{
                  fontSize: originCountry?.length > 0 ? '10px' : '12px',
                  color: tokens.colors.textSecondary,
                  fontWeight: tokens.fontWeight.semibold,
                }}
              >
                Pincode: {data.originAddressDetails?.pincode}
              </div>
            </Tooltip>
          )}
        </div>
      ) : (
        ''
      )}
    </React.Fragment>
  );
};

const renderAddressDetails = (props) => {
  const { item, style, orgMaster, classes } = props;
  if (!item) return;
  const countryName =
    isValidArray(orgMaster?.countriesList) &&
    orgMaster?.countriesList?.find((el) => el.id === item?.countryId)?.name;
  return (
    <div className={classes.addressCard} style={{ ...style }}>
      {[item?.address, item.landmark, item.city, item.state, countryName, item.pincode]
        .filter((val) => {
          return val;
        })
        .join(', ')}
    </div>
  );
};

const renderTotalPrice = (total, currency) => {
  return (
    <div style={{ display: 'flex', alignItems: 'center' }}>
      <span style={{ marginRight: 10, color: '#333', fontSize: 10 }}>Total Price</span>
      <div
        style={{
          fontSize: tokens.fontSize.small,
          fontWeight: tokens.fontWeight.semibold,
          color: '#111',
          lineHeight: '75%',
        }}
      >
        <span
          style={{
            fontSize: tokens.fontSize.caption,
            verticalAlign: 'top',
            lineHeight: '6px',
          }}
        >
          {currency[total?.currency]}
        </span>
        <span style={{ fontSize: 14 }}>{getBidTotal(total?.amount)}</span>
      </div>
    </div>
  );
};

const getRefRateUnit = (mode) => {
  if (mode === InquiryModes.FCL) return '/ container';
  if (mode === InquiryModes.LCL) return '/ cbm';
  if (mode === InquiryModes.TRAILER) return '/ trailer';
  if (mode === InquiryModes.DOMESTIC) return '/ vehicle';
  return '/ kg';
};

const getCountryId = (locationList) => {
  return locationList?.filter((item) => item?.countryId)[0]?.countryId;
};

const getTrailerOrDomesticVehicleList = (
  inquiryData,
  vehicleTypeList,
  isVehicleDetailsExpanded = false,
  stateCallback = undefined as any,
  showExpand = false
) => {
  const containerDetails = inquiryData.mode === InquiryModes.RPTL 
    ? inquiryData?.containerDetailsForRptl?.containerDetails 
    : inquiryData?.containerDetails;
  
  const vehicleList = containerDetails?.length
    ? [...containerDetails]
    : [];
  const limit = showExpand
    ? isVehicleDetailsExpanded
      ? vehicleList?.length
      : 1
    : vehicleList?.length;
  if (vehicleList?.length) {
    vehicleList.length = limit;
  }
  if (!vehicleList?.length) return '--';
  return (
    <>
      {vehicleList?.map((item) => {
        const containerMasterType = vehicleTypeList?.find((container) => {
          return container.key.type === item.type;
        })?.label?.type;
        return (
          <div style={{ marginBottom: '6px', fontWeight: 'normal' }}>
            <span style={{ fontWeight: 600 }}>{item?.count}</span>
            {containerMasterType ? <span> x </span> : ''}
            <span style={{ fontWeight: 600 }}>{containerMasterType}</span>
            {item?.size ? <span> x </span> : ''}
            <span style={{ fontWeight: 600 }}>{item?.size}</span>
            {item?.weight?.value ? <span> x </span> : ''}
            <span style={{ fontWeight: 600 }}>{item?.weight?.value}</span>&nbsp;
            <span style={{ fontWeight: 600 }}>{item?.weight?.unit}</span>
          </div>
        );
      })}
      {containerDetails?.length > 1 && showExpand && stateCallback ? (
        <div
          onClick={() => stateCallback()}
          style={{ marginTop: '10px', color: tokens.colors.primaryDark, cursor: 'pointer' }}
        >
          <span>
            {isVehicleDetailsExpanded
              ? 'View Less'
              : `${containerDetails?.length - 1} more`}
          </span>
          <span style={{ marginLeft: '2px', fontSize: `${tokens.fontSize.caption}px` }}>
            {isVehicleDetailsExpanded ? <Icon type="down" /> : <Icon type="up" />}
          </span>
        </div>
      ) : (
        ''
      )}
    </>
  );
};
const renderoverWeight=(item)=>{
  return (
    <>
    <span style={{ fontWeight: 600 }}>{item?.value}</span>&nbsp;
    <span style={{ fontWeight: 600 }}>{item?.unit}</span>
    </>
  ) ;
}

export {
  getEmptyContainerLocation,
  renderInquiryDestinationDetails,
  renderInquiryOriginDetails,
  renderTrailerDestinationDetails,
  renderAddressDetails,
  renderTotalPrice,
  getRefRateUnit,
  getCountryId,
  getTrailerOrDomesticVehicleList,
  renderoverWeight
};
